import { useSnackbarContext } from "widgets/SnackBar/SnackBar";
import tokenUtils from "utils/tokenUtils";

import { UPLOAD_COPY } from "../constants/uploadsContent";
import useUploadFile from "../hooks/useUploadFile";

const useUploadSubmit = ({
  selectedFile,
  selectedUploadAction,
  onUploadSuccess,
}) => {
  const { openSnackbar } = useSnackbarContext();
  const userId = tokenUtils.getUploaderUserId?.() ?? tokenUtils.getUserId?.();
  const { mutate: uploadFile, isPending } = useUploadFile(userId);

  const handleUpload = () => {
    if (!selectedFile || !selectedUploadAction?.scriptId || !userId) {
      return;
    }

    uploadFile(
      {
        selectedFile,
        userId,
        scriptId: selectedUploadAction.scriptId,
      },
      {
        onSuccess: (response) => {
          if (!response?.uploaded_file_id) {
            openSnackbar(UPLOAD_COPY.FAILED_MESSAGE, "error");
            return;
          }

          openSnackbar(UPLOAD_COPY.SUCCESS_MESSAGE);
          onUploadSuccess();
        },
        onError: (error) => {
          openSnackbar(
            error.message || UPLOAD_COPY.UPLOAD_ERROR_FALLBACK,
            "error"
          );
        },
      }
    );
  };

  const canUpload =
    Boolean(selectedUploadAction?.scriptId) && Boolean(selectedFile) && Boolean(userId);

  return { handleUpload, isPending, canUpload, userId };
};

export default useUploadSubmit;
